import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-client-details-modal',
    templateUrl: './client-details-modal.component.html',
    styleUrls: ['./client-details-modal.component.scss'],
    standalone: false
})
export class ClientDetailsModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ClientDetailsModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    // console.log(this.data)
  }

  onOK() {
    this.dialogRef.close(true);
  }

}
